/** 편집 단축키를 막았을 때 한 번만 이유를 알린다 (§11.2). */

export const BLOCKED_EDIT_HINT = "편집하려면 편집자 이상이어야 합니다. 플랜 관리자에게 요청하세요.";

type Listener = (message: string) => void;

let shown = false;
const listeners = new Set<Listener>();

export function hintBlockedEdit() {
  if (shown) return;
  shown = true;
  for (const listener of listeners) listener(BLOCKED_EDIT_HINT);
}

export function subscribeBlockedEdit(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
